import { render, staticRenderFns } from "./logos.vue?vue&type=template&id=20c71c4c&scoped=true&"
import script from "./logos.vue?vue&type=script&lang=js&"
export * from "./logos.vue?vue&type=script&lang=js&"
import style0 from "./logos.vue?vue&type=style&index=0&id=20c71c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c71c4c",
  null
  
)

export default component.exports